import React, {createContext, useContext, useEffect, useMemo, useState} from "react";
import {usePostMessageContext} from "./PostMessageProvider";
import {usePostMessage} from "../hooks/usePostMessage";

export type ScreensizeContextType = {
    isSmallDeviceDimension: boolean;
    isSmallInnerHeight: boolean;
};

const ScreensizeContext = createContext<ScreensizeContextType>({
    isSmallDeviceDimension: false,
    isSmallInnerHeight: false,
});

export function useScreensizeContext() {
    return useContext(ScreensizeContext);
}

type ScreensizeProviderProps = {
    children: React.ReactNode;
};

export const ScreensizeProvider = ({children}: ScreensizeProviderProps) => {
    const {postMessage} = usePostMessage();
    const [isSmallInnerHeight, setIsSmallInnerHeight] = useState(window.innerHeight < 550);

    const {isSmallDevice} = usePostMessageContext();
    const isSmallDeviceDimension = useMemo(
        () => ({isSmallDeviceDimension: isSmallDevice}),
        [isSmallDevice],
    );

    useEffect(() => {
        // We only want to call this on mount
        postMessage("updateWidth");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallInnerHeight(window.innerHeight < 550);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const values = useMemo(
        () => ({
            ...isSmallDeviceDimension,
            isSmallInnerHeight,
        }),
        [isSmallDeviceDimension, isSmallInnerHeight],
    );

    return <ScreensizeContext.Provider value={values}>{children}</ScreensizeContext.Provider>;
};
